import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { OrderPreviewCancelCommandResult, OrderPreviewCheckoutCommandResult, OrderPreviewGetQueryResult } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IOrderPreviewApiService {

  abstract orderPreviewGet(
    cartNumber: number,
    validateCart?: boolean | undefined,
    belegDidToAdd?: string[] | undefined
  ): Observable<OrderPreviewGetQueryResult>;

  abstract orderPreviewCheckout(
    cartNumber: number,
    belegDidToAdd?: string[] | undefined,
    sendConfirmationCopyToCustomer?: boolean,
    contactCustomer?: boolean | undefined,
    contactCustomerText?: string | undefined
  ): Observable<OrderPreviewCheckoutCommandResult>;

  abstract orderPreviewCancel(shoppingCartNumber: number, belegDidToAdd?: string[] | undefined): Observable<OrderPreviewCancelCommandResult>;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IOrderPreviewApiServiceToken = new InjectionToken<IOrderPreviewApiService>('IOrderPreviewApiServiceToken');
